import React, { useState, useContext } from "react";
import { saltEncryptAndEncode } from "../utility/saltEncryption";

const redirectContext = React.createContext(null);
const { Provider } = redirectContext;

const useRedirectProvider = () => {
  const [redirectURL, setRedirectURL] = useState(null);
  const [redirectParams, setRedirectParams] = useState(null); // Array of {label: string, salt: true|false, saltKey: string|undefined}

  const getRedirectURL = (data) => {
    if (!redirectURL) return null;
    let to = decodeURIComponent(redirectURL);
    if (redirectParams && redirectParams.length > 0) {
      redirectParams.forEach((param, idx) => {
        to += `${idx === 0 ? "?" : "&"}${param.label}=${
          !(param.salt && param.saltKey)
            ? data[param.label]
            : saltEncryptAndEncode(`${data[param.label]}`, `${param.saltKey}`)
        }`;
      });
    }
    return to;
  };

  return {
    redirectURL,
    setRedirectURL,
    redirectParams,
    setRedirectParams,
    getRedirectURL,
  };
};

export const RedirectProvider = ({ children }) => {
  const auth = useRedirectProvider();
  return <Provider value={auth}>{children}</Provider>;
};

export const useRedirect = () => useContext(redirectContext);
